import NewsEntry from './news-entry';

export default class NewsEntryDesktop extends NewsEntry {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/news/entry/news-entry.desktop.js